<script setup lang="ts">
import { ref } from 'vue';
import SeedanceResultsFeed from '~/components/seedance/SeedanceResultsFeed.vue';
import rawTemplates from './seedance-templates.json';

// 结果面板始终展示「Your generations」结果流（示例 + 生成历史）。
// 生成走非阻塞流：EditorPanelSeedance 提交后 emit('submitted') → editor.vue 调用
// 本组件 refreshFeed()，结果流顶部立即出现「生成中」卡片并自行轮询翻新，
// 不再切到整屏「Generating…」文案，也不做阻塞式长轮询。
defineProps<{
  // 兼容旧接线（editor.vue 仍传入），当前不再使用
  result?: { url: string; type: 'image' | 'video' } | null;
  generating?: boolean;
  label?: string;
}>();
const emit = defineEmits<{
  (e: 'use-example'): void;
  (e: 'use-video', video: any): void;
}>();

// 结果流第一张的官方示例模板
const exampleTemplate =
  ((rawTemplates as any).image ?? []).find((t: any) => t.id === 'sample-image-6') ?? null;

const feedRef = ref<InstanceType<typeof SeedanceResultsFeed> | null>(null);
// 供 editor.vue 在提交成功后调用，刷新出「生成中」卡片
defineExpose({ refreshFeed: () => (feedRef.value as any)?.refresh?.() });
</script>

<template>
  <div class="result-panel">
    <div class="stage empty">
      <SeedanceResultsFeed
        ref="feedRef"
        :example="exampleTemplate"
        @use-example="emit('use-example')"
        @use-video="emit('use-video', $event)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.result-panel {
  @apply rounded-2xl bg-neutral-900/70 border border-white/5 p-4 md:p-6;
  min-height: 480px;
  display: flex;
  align-items: stretch;
}
/* 桌面端：填满右列（flex 子项），与左侧设置面板等高 */
@media (min-width: 768px) {
  .result-panel {
    flex: 1;
    min-height: 0;
  }
}
.stage {
  @apply flex flex-col w-full;
}
.stage.empty {
  @apply items-stretch justify-start text-left;
}
/* 桌面端：结果流在卡片内部滚动（卡片本身固定高，随左侧等高） */
@media (min-width: 768px) {
  .stage.empty {
    min-height: 0;
    overflow-y: auto;
  }
}
</style>
